import { SETH_LOGIN_REDIRECT } from "@/constants";

export const htmlEncode = (s) => {
  const el = document.createElement("div");
  let str = s;
  str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
  str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
  el.innerHTML = str;
  const returnString = el.textContent;
  return returnString;
};

export const getDomainAndProtocolFromUrl = (url) => {
  if (url) {
    // Split the URL by '//' to isolate the protocol and the rest of the URL
    let parts = url.split("//");
    // The protocol should be the first part
    let protocol = parts[0];
    // Remove '//' and any following slashes
    let urlWithoutProtocol = parts[1].replace(/^\/+/g, "");
    // Split the remaining string by '/' to isolate the domain
    let domainParts = urlWithoutProtocol.split("/");
    // The domain is the first part before any '/' characters
    let domain = domainParts[0];

    return protocol + "//" + domain;
  }
};

export const getFullUrl = (href, query = {}, removeFilters) => {

  const { offerCategory, segment, customTags } = query;
  const queryParamsToKeep = {};
  const [hrefPathname, hrefSearch = ''] = href.split('?');
  const hrefQueryParams = new URLSearchParams(hrefSearch);

  if (offerCategory) {
    queryParamsToKeep.offerCategory = offerCategory;
  }

  if (segment) {
    queryParamsToKeep.segment = segment;
  }

  //Contingencia para poder borrar el filtro de renovacion
  if (removeFilters) {
    delete query.customTags;
  }

  if (customTags && !removeFilters) {
    queryParamsToKeep.customTags = customTags;
  }

  Object.keys(queryParamsToKeep).forEach(key => {
    hrefQueryParams.set(key, query[key]); // Reemplaza o añade el valor
  });

  const fullUrl = `${hrefPathname}${hrefQueryParams.toString() ? `?${hrefQueryParams.toString()}` : ''}`;
  return fullUrl;
}

const isAEMStatic = (path) => {
  return path && path.startsWith("/content/dam/movistar");
}

export const getFullAEMStaticSrc = (pathname, currentEnv) => {
  let basePath = "";
  if (isAEMStatic(pathname)) {
    // Caso productivo
    if (!currentEnv || currentEnv === "prod" || currentEnv === "local") {
      basePath = "https://prod.adb.col.movistar.es";
      // Resto de entornos no productivos
    } else {
      basePath = "https://author.prod.aem.col.movistar.es";
    }
  }
  return `${basePath}${pathname}`;
};

export const goLoginCallbackUrl = (callbackUrl) => {
  return `${SETH_LOGIN_REDIRECT}${encodeURIComponent(callbackUrl)}`;
}
